import React, { TextareaHTMLAttributes } from 'react';

import { Container, TextAreaContainer } from './styles';

export type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
};

const TextArea: React.ForwardRefRenderFunction<any, TextAreaProps> = (
  { id, label, ...rest },
  ref,
) => {
  return (
    <Container>
      {label && <label htmlFor={id}>{label}</label>}
      <TextAreaContainer>
        <textarea id={id} ref={ref} {...rest} />
      </TextAreaContainer>
    </Container>
  );
};

export default React.forwardRef(TextArea);
